module.exports = __webpack_public_path__ + "static/media/x-icon.6019a8a4.svg";